// Feature flags. Flip via env var (VITE_ENABLE_SAMEBRAIN=true) or edit defaults here.
export const SAMEBRAIN_GAME_ENABLED =
  import.meta.env.VITE_ENABLE_SAMEBRAIN === "true";
